module.exports = __webpack_public_path__ + "static/media/timbNomina.7559dace.png";